import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { ReportListing } from '~/components/report/ReportListing';

export default function CompanyReportsRoute() {
  useBreadcrumb('routes/my-safari/reports/company', 'Company Reports');
  return <ReportListing isCompany />;
}
